import React from 'react';

function DiscussProject({ setView }) {
  const handleCallClick = (e) => {
    e.preventDefault();
    const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    } else if (setView) {
      window.history.pushState({}, '', '/contact/');
      setView('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="discuss-project">
      {/* Cityscape background image */}
      <div
        className="discuss-project-bg"
        style={{ backgroundImage: "url('/assets/images/cityscape_dark_night.png')" }}
      ></div>
      <div className="discuss-project-overlay"></div>

      <div className="container discuss-project-container">
        <div className="discuss-project-watermark">Discuss Project</div>

        <div className="discuss-project-content">
          <h2 className="discuss-project-title">Professional Excellence</h2>
          <p className="discuss-project-desc">
            We are a full fledge BPO company and offer a full range of next generation business process outsourcing services, IT solutions, web design, web development and digital marketing services. Scalable bandwidth backs our services to meet the needs of businesses of all sizes. We integrate our tools, processes, and expertise to help manage your financial operations, reduce risks, and increase customer interactions. Being one of the top BPO companies in Pakistan our solutions serve a wide variety of industries, including Banking, Financial Services, Consumer Goods, Retail, Food & Beverage, Apparel & Footwear, Insurance, Pharmaceuticals, Telecom, Healthcare, and Manufacturing.
          </p>

          <button className="btn-schedule btn-discuss-call" onClick={handleCallClick}>
            Start with a free call
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default DiscussProject;
